<template>
  <v-dialog
    :value="open"
    content-class="timeslapse_dialog"
    max-width="395px"
    @click:outside="handleOutside"
  >
    <v-btn
      icon
      class="timeslapse_dialog-closeIcon"
      tabindex="-1"
      @click="$emit('onClose')"
    >
      <v-icon color="darken-2"> mdi-close </v-icon>
    </v-btn>
    <v-card>
      <v-card-title class="timeslapse_dialog-title">
        <span>タイムラプス</span>
      </v-card-title>

      <v-card-text class="timeslapse_dialog-text">
        <v-container class="timeslapse_dialog-container">
          <v-divider />
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <span class="timeslapse_slider-title">倍速</span>
              <section class="timeslapse_slider-wrapper">
                <vue-slider
                  v-model="sliderValue"
                  :tooltip="'none'"
                  direction="ltr"
                  :min="min"
                  :max="max"
                  :duration="0"
                  width="292px"
                  dot-size="24"
                />
                <span class="timeslapse_slider-value">{{ sliderValue }}</span>
              </section>
              <section class="timeslapse_slider-info">
                <span class="timeslapse_slider-record--label">録画時間</span>
                <span class="timeslapse_slider-record--time">{{
                  recordTimeFormat
                }}</span>
                <img
                  class="timeslapse_slider-arrow"
                  src="@/assets/img/icon_arrow.svg"
                />
                <span class="timeslapse_slider-save--label">保存時間</span>
                <span class="timeslapse_slider-save--time">{{
                  saveTimeFormat
                }}</span>
              </section>
            </v-col>
          </v-row>
          <v-divider />
        </v-container>
      </v-card-text>

      <v-card-actions class="timeslapse_dialog-actions">
        <v-btn
          class="timeslapse_dialog-btn timeslapse_dialog-cancel"
          color="text"
          @click="handleCancel"
        >
          キャンセル
        </v-btn>
        <v-spacer />
        <v-btn
          class="timeslapse_dialog-btn timeslapse_dialog-ok"
          color="primary"
          :loading="loading"
          @click="handleOK"
        >
          保存
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import dayjs from 'dayjs';
import VueSlider from 'vue-slider-component';
export default {
  name: 'TimeslapseDialog',
  components: {
    VueSlider,
  },
  props: {
    open: {
      type: Boolean,
    },
    min: { type: Number, default: 2 },
    max: { type: Number, default: 72 },
    recordTime: { type: Number, default: 0 },
  },
  data() {
    return {
      sliderValue: 10,
      loading: false,
    };
  },
  computed: {
    recordTimeFormat() {
      return dayjs.duration(this.recordTime).format('HH:mm:ss');
    },
    saveTime() {
      return this.recordTime / this.sliderValue;
    },
    saveTimeFormat() {
      return dayjs.duration(this.saveTime).format('mm:ss');
    },
  },
  methods: {
    close() {
      this.$emit('onClose');
    },
    handleOutside(e) {
      e.preventDefault();
      e.stopPropagation();
      this.close();
    },
    handleCancel() {
      this.close();
    },
    handleOK() {
      this.$emit('onTrim', this.sliderValue);
      this.close();
    },
  },
};
</script>

<style lang="scss">
.timeslapse {
  .v-btn {
    margin-top: 10px;
    &:not(.v-btn--round).v-size--x-small {
      padding-left: 8px;
      padding-right: 8px;
      &.v-btn--outlined {
        padding-left: 7px;
        padding-right: 7px;
        color: #989898;
        border-color: #989898;
      }
    }
    &:not(:last-child) {
      margin-right: 8px;
    }
  }
  .v-dialog > .v-card > .v-card__title {
    padding: 0;
  }
  &_dialog {
    position: relative;
    &-cancel {
      &.v-btn:not(.v-btn--round).v-size--default {
        width: 120px;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: normal;
        text-align: center;
        color: #989898;
      }
    }
    &-ok {
      &.v-btn:not(.v-btn--round).v-size--default.primary {
        width: 120px;
        height: 36px;
        padding: 8px 16px;
        border-radius: 5px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
        background-color: #0075c2;
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.14;
        letter-spacing: normal;
        text-align: center;
        color: #fff;
      }
    }
    &-btn {
      width: 120px;
      font-size: 14px !important;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: normal;
      text-align: center;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.16);
    }
    &-closeIcon {
      &.v-btn {
        &.v-btn--icon.v-size--default {
          position: absolute;
          right: 3px;
          top: 3px;
          z-index: 1;
        }

        .v-icon {
          margin-right: 0;
          font-size: 20px;
          color: #999;
          font-weight: bold;
        }

        &:not(.v-btn--text):not(.v-btn--outlined):hover:before,
        &.theme--light:hover::before {
          opacity: 0;
        }
      }
    }
    &-container {
      padding: 0 !important;
      .v-divider {
        border-color: #ccc;
      }
      .row {
        padding-top: 20px;
        padding-bottom: 30px;
      }
      & .vue-slider {
        margin: 10px 0;
        .vue-slider-dot-handle {
          box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
        }
        .vue-slider-process {
          background-color: #0075c2;
        }
      }
    }
    &-content {
      margin: 20px 0;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: normal;
      text-align: center;
      color: #666;
    }
    &-actions {
      &.v-card__actions {
        padding: 0;
        margin-top: 20px;
      }
    }
    &-text {
      padding: 0 !important;
      margin-top: 20px;
    }
    &-title {
      &.v-card__title {
        padding: 0 !important;
      }
      span {
        font-family: 'Noto Sans JP', sans-serif;
        font-size: 14px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 0.79;
        letter-spacing: normal;
        text-align: left;
        color: #4b4b4b;
      }
    }
  }
  &_slider {
    &-wrapper {
      display: flex;
      align-items: center;
    }
    &-title {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #666;
    }
    &-value {
      font-size: 20px;
      font-weight: 600;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.1;
      letter-spacing: normal;
      text-align: center;
      color: #0075c2;
      margin-left: 16px;
    }
    &-info {
      display: flex;
      & > span {
        display: block;
        margin-right: 10px;
      }
    }
    &-arrow {
      margin-right: 10px;
    }
    &-record {
      &--label {
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: left;
        color: #666;
      }
      &--time {
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: left;
        color: #666;
      }
    }
    &-save {
      &--label {
        font-size: 14px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: left;
        color: #666;
      }
      &--time {
        font-size: 16px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: center;
        color: #0075c2;
      }
    }
  }
}
</style>
